import { ErrorCode, PortalApiError } from '@afterpaytouch/portal-api/types'
import { TrackingEvent } from '../../model/monitoring'
import { checkoutService } from '@afterpaytouch/portal-api/consumer/checkout'
import { paymentScheduleService } from '@afterpaytouch/portal-api/consumer/paymentSchedule'
import { setRecoverableFlowStatus } from '../../state'
import { RecoverableTerminalErrorStatus } from '@afterpay/types'
import { errorCodeRoute, Route } from '../../config/router'
import { recoverableTerminalErrorWhiteList } from '../../model/errors'
import { ErrorHandler, CheckoutErrorContext } from './types'

export const startRecoverableTerminalErrorFlow = (
  errorCode: ErrorCode,
  { dispatch, logEvent }: Pick<CheckoutErrorContext, 'dispatch' | 'logEvent'>
): Route | undefined => {
  logEvent(TrackingEvent.CHECKOUT_DECLINED, {
    isRecoverableTerminalError: true,
    errorCode,
  })

  dispatch(checkoutService.util.resetApiState())
  dispatch(paymentScheduleService.util.resetApiState())
  dispatch(setRecoverableFlowStatus(RecoverableTerminalErrorStatus.Initial))

  return errorCodeRoute[errorCode]
}

export const createCheckoutStartRecoverableTerminalErrorHandler = (): ErrorHandler => {
  return {
    canHandle: (errorCode: ErrorCode, error: PortalApiError): boolean => {
      if (!recoverableTerminalErrorWhiteList.includes(errorCode)) {
        return false
      }

      if (error?.errorInfo?.pay_monthly_only !== undefined) {
        return false
      }

      const riskDeclines = error?.errorInfo?.number_of_risk_declines
      if (riskDeclines && parseInt(riskDeclines) > 1) {
        return false
      }

      const ordersToBePaid = error?.errorInfo?.number_of_orders_to_be_paid
      if (ordersToBePaid && parseInt(ordersToBePaid) > 1) {
        return false
      }

      return true
    },

    handle: async (errorCode: ErrorCode, error: PortalApiError, context: CheckoutErrorContext): Promise<Route | undefined> =>
      startRecoverableTerminalErrorFlow(errorCode, context),
  }
}
